import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import HowToRegIcon from "@mui/icons-material/HowToReg";
import PersonAddIcon from "@mui/icons-material/PersonAdd";

import { NotificationType } from "Notifications/Api/notificationApi";

export const notificationIconMap: Record<NotificationType, React.ElementType> =
  {
    [NotificationType.SysAdmin_ActorWithdrawalRequested]:
      AccountBalanceWalletIcon,
    [NotificationType.SysAdmin_PartnerRegistrationRequested]: HowToRegIcon,
    [NotificationType.SysAdmin_ActorRegistrationRequested]: PersonAddIcon,
    [NotificationType.Partner_JobApprovedByActor]: CheckCircleOutlineIcon,
    [NotificationType.Partner_JobRejectedByActor]: HighlightOffIcon,
  };
